export function sLog () {}

sLog.LEVEL = {
  RUN: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  VERBOSE: 5,
}

//sLog.level = sLog.LEVEL.DEBUG
sLog.level = sLog.LEVEL.RUN

// log error
if (sLog.level >= sLog.LEVEL.ERROR) {
  sLog.error = console.error.bind(console)
}
else {
  sLog.error = function () {}
}
// log warn
if (sLog.level >= sLog.LEVEL.WARN) {
  sLog.warn = console.warn.bind(console)
}
else {
  sLog.warn = function () {}
}
// log info
if (sLog.level >= sLog.LEVEL.INFO) {
  sLog.info = console.info.bind(console)
}
else {
  sLog.info = function () {}
}
// log debug
if (sLog.level >= sLog.LEVEL.DEBUG) {
  sLog.debug = console.log.bind(console)
}
else {
  sLog.debug = function () {}
}
// log verbose
if (sLog.level >= sLog.LEVEL.VERBOSE) {
  sLog.verbose = console.log.bind(console)
}
else {
  sLog.verbose = function () {}
}



// WEBPACK FOOTER //
// ./src/common/simple-logger.js